import api from '~api'
import {
  convertPages,
  convertMedia
} from '~utils/api'

export const url = '/corporate-visit'

export async function getEnterpriseVisits (params) {
  const {
    data
  } = await api.get(`${url}`, {
    params
  })

  const visits = data.data.map((visit) => {
    return {
      visit_id: visit.id,
      visit_company: visit.name,
      visit_start_date: visit.event_start_date,
      visit_end_date: visit.event_end_date,
      visit_show_status: visit.show_status,
      visit_students_count: visit.students_count,
      visit_taker: visit.taker
    }
  })

  const pages = convertPages(data.meta)

  return ({
    visits,
    pages
  })
}

export async function getVisitsById (id) {
  const {
    data
  } = await api.get(`${url}/${id}`)

  const response = data.data

  const visit = {
    visit_id: response.id,
    visit_name: response.name,
    visit_start_date: response.start_date,
    visit_end_date: response.end_date,
    visit_location: response.location,
    visit_event_start_date: response.event_start_date,
    visit_event_end_date: response.event_end_date,
    visit_note: response.note,
    visit_content: response.content,
    visit_attachments: convertMedia(response.media),
    visit_insurance_info: Boolean(response.privacy),
    visit_show_status: response.show_status,
    visit_students_count: response.students_count,
    visit_taker: response.taker

  }
  return (visit)
}
